(function () {
  'use strict';

  /* @ngdoc object
   * @name electronicLogBook
   * @description
   *
   */
  angular
    .module('crewPositionsReport', [
      'ui.router'
    ]);
}());
